import React, { useEffect, useState } from 'react'
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { Box } from '@mui/system';
import NotificationsMenu from './singleButtons/NotificationsMenu';
import MessagesMenu from './singleButtons/MessagesMenu';

const NotificationsContainer = () => {
    const axiosPrivate = useAxiosPrivate();
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const getUnreadNotifications = async () => {
            try {
                const response = await axiosPrivate.get("/Notifications/list?where_key=read&where_value=false&complete=true&order_key=created_at&order_desc=true");
                if (response) {
                    setNotifications(response.data?.result.list_element);
                }
            } catch (err) {
                console.error("Errore durante la richiesta:", err);
                if (!err?.response) {
                    window.alert("Errore. Riprova");
                } else if (err.response?.status === 401) {
                    window.alert("Non sei autorizzato");
                } else {
                    window.alert("Errore. Riprova");
                }
            }
        }

        getUnreadNotifications();
    }, [])

    const chatMessages = notifications.filter(
        (msg) =>
          msg["messages.message"] &&
          msg["messages.message"].includes("Nuovo messaggio sulla pratica")
      );
      
      const otherMessages = notifications.filter(
        (msg) =>
          !msg["messages.message"] ||
          !msg["messages.message"].includes("Nuovo messaggio sulla pratica")
      );

    return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            <MessagesMenu notifications={chatMessages} notificationsCount={chatMessages.length} />
            <NotificationsMenu notifications={otherMessages} notificationsCount={otherMessages.length} />
        </Box>
    )
}

export default NotificationsContainer